import { Link, Outlet, useLocation } from "react-router-dom";

export function AppLayout() {
  const location = useLocation();
  const quiet = location.pathname.startsWith("/l/");
  return (
    <div className={quiet ? "app app--quiet" : "app"}>
      <a className="skip-link" href="#main">
        Skip to content
      </a>
      <header className="site-header">
        <Link className="wordmark" to="/" aria-label="Fold home">
          <span className="wordmark__mark" aria-hidden="true">
            F
          </span>
          <span>Fold</span>
        </Link>
        {quiet ? null : (
          <nav aria-label="Primary navigation">
            <Link to="/privacy">Privacy</Link>
            <Link className="button button--small" to="/create">
              Write a letter
            </Link>
          </nav>
        )}
      </header>
      <main id="main">
        <Outlet />
      </main>
      {quiet ? null : (
        <footer className="site-footer">
          <p>Handwritten by you. Delivered anywhere.</p>
          <div>
            <Link to="/privacy">Privacy</Link>
            <Link to="/terms">Terms</Link>
          </div>
        </footer>
      )}
    </div>
  );
}
